"use client";

import { useEffect, useRef, useState } from "react";
import { worldBus, type WorldMode } from "@/lib/world-bus";
import styles from "./WorldRoot.module.css";

// Respaldo sin WebGL (guía 7.8): fotogramas fijos de la propia escena (generados con
// scripts/fotogramas.mjs en public/fondo/) con el mismo texto encima. Nunca una pantalla
// negra. Solo se monta si el mundo no puede arrancar: no pesa en la carga normal.

const HOME_FRAMES: [number, string][] = [
  [0, "inicio-0"],
  [2, "inicio-2"],
  [3.5, "inicio-3"],
  [3.95, "inicio-4"],
  [4.7, "inicio-5"],
  [5, "inicio-6"],
  [5.5, "inicio-6-vidriera"],
  [5.66, "inicio-6-pasillo"],
  [5.93, "inicio-6-tajy"],
  [7.1, "inicio-7"],
  [7.8, "inicio-8"],
  [8.9, "inicio-9"],
  [9.9, "inicio-10"],
];

const MODE_FRAMES: Record<Exclude<WorldMode, "home">, string> = {
  research: "investigacion",
  models: "modelos",
  audit: "auditoria",
  still: "quieto",
  lost: "perdido",
  market: "mercado",
  background: "fondo",
};

function frameFor(mode: WorldMode, u: number) {
  if (mode !== "home") return MODE_FRAMES[mode];
  let best = HOME_FRAMES[0];
  for (const f of HOME_FRAMES) if (Math.abs(f[0] - u) < Math.abs(best[0] - u)) best = f;
  return best[1];
}

export function FallbackFrames() {
  const [frame, setFrame] = useState(() => frameFor(worldBus.mode, worldBus.u));
  const last = useRef(frame);

  useEffect(() => {
    let raf = 0;
    const loop = () => {
      raf = requestAnimationFrame(loop);
      const f = frameFor(worldBus.mode, worldBus.u);
      if (f !== last.current) {
        last.current = f;
        setFrame(f);
      }
    };
    raf = requestAnimationFrame(loop);
    return () => cancelAnimationFrame(raf);
  }, []);

  return (
    // Fotograma decorativo: el texto de la página ya dice lo que muestra.
    // eslint-disable-next-line @next/next/no-img-element
    <img key={frame} className={styles.fallback} src={`/fondo/${frame}.webp`} alt="" decoding="async" />
  );
}
